import Navigation from './Navigation';
import TopHeader from './TopHeader';
import TabMenu from './TabMenu';
import Footer from './Footer';
import Bantuan from './Bantuan';
import DataDiri from './tabmenu/DataDiri';
import JadwalUkt from './tabmenu/JadwalUkt';
import JadwalKlarifikasi from './JadwalKlarifikasi';
import KetentuanKlarifikasi from './KetentuanKlarifikasi';
import NominalUKT from './NominalUKT';
import TabelUkt from './tabmenu/TabelUkt';
import BatalUktTinggi from './BatalUktTinggi';
import BatalUktRendah from './BatalUktRendah';
import InfoUktTinggi from './InfoUktTinggi';
import UktLoader from './UktLoader';
import VerifikasiSNMPTN from './VerifikasiSNMPTN';
import InformasiKIPK from './InformasiKIPK';

import AlurUKT from './tabmenu/AlurUKT';
import UnduhBerkas from './tabmenu/UnduhBerkas';
import DaftarBerkas from './tabmenu/DaftarBerkas';
import FAQ from './tabmenu/FAQ';
import InfoBiodata from './tabmenu/InfoBiodata';

import UktTinggi from './tabmenu/UktTinggi';
import UktRendah from './tabmenu/UktRendah';

import GabungBerkas from './petunjuk/GabungBerkas';
import TagihanListrik from './petunjuk/TagihanListrik';
import UkuranBerkas from './petunjuk/UkuranBerkas';

import FormLogin from './form/Login';

import DataPribadi from './form/ukt-tinggi/DataPribadi';
import DataAyah from './form/ukt-tinggi/DataAyah';
import DataIbu from './form/ukt-tinggi/DataIbu';
import DataWali from './form/ukt-tinggi/DataWali';
import DataPendukung from './form/ukt-tinggi/DataPendukung';
import Verifikasi from './form/ukt-tinggi/Verifikasi';

import DataPribadiSeleksi from './form/ukt-seleksi/DataPribadiSeleksi';
import DataAyahSeleksi from './form/ukt-seleksi/DataAyahSeleksi';
import DataIbuSeleksi from './form/ukt-seleksi/DataIbuSeleksi';
import DataWaliSeleksi from './form/ukt-seleksi/DataWaliSeleksi';
import DataRumahSeleksi from './form/ukt-seleksi/DataRumahSeleksi';
import DataListrikSeleksi from './form/ukt-seleksi/DataListrikSeleksi';
import DataKendaraanSeleksi from './form/ukt-seleksi/DataKendaraanSeleksi';
import DataPendukungSeleksi from './form/ukt-seleksi/DataPendukungSeleksi';
import VerifikasiSeleksi from './form/ukt-seleksi/VerifikasiSeleksi';

export {
    Navigation,
    TopHeader,
    TabMenu,
    Footer,
    Bantuan,
    DataDiri,
    JadwalUkt,
    JadwalKlarifikasi,
    KetentuanKlarifikasi,
    NominalUKT,
    TabelUkt,
    BatalUktTinggi,
    BatalUktRendah,
    InfoUktTinggi,
    UktLoader,
    VerifikasiSNMPTN,
    InformasiKIPK,
    AlurUKT,
    UnduhBerkas,
    DaftarBerkas,
    FAQ,
    UktTinggi,
    UktRendah,
    GabungBerkas,
    TagihanListrik,
    UkuranBerkas,
    FormLogin,
    DataPribadi,
    DataAyah,
    DataIbu,
    DataWali,
    DataPendukung,
    Verifikasi,
    DataPribadiSeleksi,
    DataAyahSeleksi,
    DataIbuSeleksi,
    DataWaliSeleksi,
    DataRumahSeleksi,
    DataListrikSeleksi,
    DataKendaraanSeleksi,
    DataPendukungSeleksi,
    VerifikasiSeleksi,
    InfoBiodata,
};
